<p-radioButton
    [name]="group"
    [value]="value"
    [label]="label | translate"
    [formControl]="formControl">
</p-radioButton>
